// src/index.ts
import { join } from "node:path";
function getGitIgnoredFolder(projectFolder = "") {
  return join(projectFolder, ".wix");
}
function getTypesDir(projectFolder) {
  return join(getGitIgnoredFolder(projectFolder), "types");
}
function getPageTypesDir(projectFolder, pageId) {
  return join(getTypesDir(projectFolder), pageId);
}
function getPageConfigFilename(projectFolder, pageId) {
  return join(getPageTypesDir(projectFolder, pageId), `jsconfig.json`);
}
function getBackendConfigPath(projectFolder) {
  return join(getTypesDir(projectFolder), "backend", "jsconfig.json");
}
function getPublicConfigPath(projectFolder) {
  return join(getTypesDir(projectFolder), "public", "jsconfig.json");
}
function getSourceFolder(projectFolder) {
  return join(projectFolder, "src");
}
function getPagesFolder(projectFolder = "") {
  return join(getSourceFolder(projectFolder), "pages");
}
function getPublicFolder(projectFolder = "") {
  return join(getSourceFolder(projectFolder), "public");
}
function getBackendFolder(projectFolder = "") {
  return join(getSourceFolder(projectFolder), "backend");
}
function getStylesFolder(projectFolder = "") {
  return join(getSourceFolder(projectFolder), "styles");
}
var SLASH = "/";
var ENCODED_SLASH = "\\\\";
function encodeSlash(string) {
  return string.replaceAll(new RegExp(SLASH, "g"), ENCODED_SLASH);
}
function getPageCodeFilePath(projectFolder, page, shouldEscapeSlash = false) {
  const pageTitle = shouldEscapeSlash ? encodeSlash(page.pageTitle) : page.pageTitle;
  return join(
    getPagesFolder(projectFolder),
    `${[pageTitle, page.pageMetaData.pageId].filter(Boolean).join(".")}.js`
  );
}
export {
  encodeSlash,
  getBackendConfigPath,
  getBackendFolder,
  getGitIgnoredFolder,
  getPageCodeFilePath,
  getPageConfigFilename,
  getPageTypesDir,
  getPagesFolder,
  getPublicConfigPath,
  getPublicFolder,
  getSourceFolder,
  getStylesFolder,
  getTypesDir
};
